import {
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { userDataSummaryLabels } from "../../../../utility/constants";
import { getNoOfItems, getTimeStampFilterItem } from "utility/helper";

dayjs.extend(utc);

const CdadHeaderTopFilterComponent = (props: any) => {

const getUserDataSummaryData = (listId: string) => {
    switch (listId) {
      case "MASKED-VIN_list":
        return props?.vinList?.length;
      case "vehicleName":
        return getNoOfItems(props?.data, "vehicleName")?.length;
      case "DispatchModelType":
        return getNoOfItems(props?.data, "DispatchModelType")?.length;
      case "min_timestamp":
        return getTimeStampFilterItem(props?.data, "min_timestamp", "min");
      case "max_timestamp":
        return getTimeStampFilterItem(props?.data, "max_timestamp", "max");
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      {userDataSummaryLabels?.map((item: any, index: number) => {
        return (
          <DataDisplayField field={item.label} value={getUserDataSummaryData(item.id)} key={index} id={item.id} />
        )
      })}
    </div>
  );
};

export default CdadHeaderTopFilterComponent;

export interface DataDisplayFieldProps {
  field: string, value: string, id: string
}

export const DataDisplayField = (props: DataDisplayFieldProps) => {
  const width: string = props?.id === 'MASKED-VIN_list' ? '15%' : props?.id === 'DispatchModelType' ? '25%' : '20%';
  return (
    <div style={{
      display: 'flex',
      width: width,
      border: '1px solid #D9D9D9',
      height: '48px',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: '4px'
    }}>
      <Typography sx={{ margin: '4px' }}>{props.field}</Typography>
      <Typography sx={{ margin: '4px' }}>{props.value}</Typography>
    </div>
  )
}
